var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0993 9.92309V6.23059C10.0993 5.55059 9.54844 4.99976 8.86844 4.99976C8.18844 4.99976 7.6376 5.55059 7.6376 6.23059V13.3331L5.4326 12.2014C4.93094 11.9439 4.3201 12.0398 3.92177 12.4381C3.39427 12.9656 3.41927 13.8281 3.97594 14.3248L7.99677 17.9106C8.3026 18.1823 8.69677 18.3331 9.10594 18.3331H12.9668C13.7476 18.3331 14.4243 17.7906 14.5934 17.0281L15.4876 13.0031C15.7484 11.8281 14.9626 10.6764 13.7734 10.4923L10.0993 9.92309Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78003 5.83317C4.78003 3.53234 6.64586 1.6665 8.9467 1.6665C11.2475 1.6665 13.1134 3.53234 13.1134 5.83317",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardIcon);
export default ForwardRef;